import React, { useState, useCallback } from "react";

const WithDragAndDrop = ({
    onFilesSelected,
    disabled = false,
    children,
    additionalClassNames = "",
    dropMessageClasses = '',
    dropMessage = "Drop file here",
}) => {
    const [isDragActive, setIsDragActive] = useState(false);

    const handleDragOver = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;
            setIsDragActive(true);
        },
        [disabled]
    );

    const handleDragLeave = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;

            // Fix flicker — only deactivate when leaving the entire container
            if (!e.currentTarget.contains(e.relatedTarget)) {
                setIsDragActive(false);
            }
        },
        [disabled]
    );

    const handleDrop = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;

            setIsDragActive(false);

            const files = e?.dataTransfer?.files || [];
            const syntheticEvent = {
                ...e,
                target: { files },
                dataTransfer: e.dataTransfer,
            };

            if (onFilesSelected) onFilesSelected(syntheticEvent);
        },
        [onFilesSelected, disabled]
    );

    return (
        <div
            className={`relative overflow-hidden ${
                "cursor-pointer"
            }
            ${isDragActive ? "border-2 bg-blue-50 rounded-xl" : ""}
            ${additionalClassNames}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            {typeof children === "function"
                ? children({ isDragActive, disabled })
                : children}

            {isDragActive && !disabled && (
                <div
                    className="absolute inset-0 flex flex-col items-center justify-center 
                    bg-white/80 backdrop-blur-sm text-primaryColor rounded-xl z-20
                    pointer-events-none text-center transition-all duration-150"
                >
                    <span
                        className={`text-primaryColor font-semibold text-base sm:text-lg md:text-sm ${dropMessageClasses}`}
                    >
                        {dropMessage}
                    </span>
                </div>
            )}
        </div>
    );
};

export default WithDragAndDrop;
